(() => {
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reviewer names from the reviews app: first name plus last initial. */
  const NAME_SELECTOR = '.jdgm-carousel-item__reviewer-name, .jdgm-rev__author';

  const shortenName = (name) => {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length < 2) return parts[0] || '';
    return `${parts[0]} ${parts[parts.length - 1].charAt(0)}.`;
  };

  const shortenNames = () => {
    document.querySelectorAll(`:is(${NAME_SELECTOR}):not([data-candly-short])`).forEach((element) => {
      element.textContent = shortenName(element.textContent);
      element.dataset.candlyShort = 'true';
    });
  };

  /* Free-shipping bar in the cart drawer. The drawer re-renders on every cart change, so the
     fill is animated from its previous width, and reaching the threshold gets a short
     confetti puff from the end of the bar. */
  const CONFETTI_COLORS = ['#c87447', '#b4532a', '#3a1503', '#e8d3b9', '#e0a84e'];
  const random = (min, max) => min + Math.random() * (max - min);
  let freeShippingReached = Boolean(document.querySelector('.candly-freeship--reached'));
  let lastFreeShippingPercent = null;

  const throwConfetti = (bar) => {
    const origin = document.createElement('span');
    origin.className = 'candly-confetti';
    origin.setAttribute('aria-hidden', 'true');
    bar.appendChild(origin);

    let longest = 0;
    for (let index = 0; index < 16; index++) {
      const drift = document.createElement('span');
      const piece = document.createElement('i');
      const size = random(0.5, 0.9);
      piece.style.background = CONFETTI_COLORS[index % CONFETTI_COLORS.length];
      piece.style.width = `${size}rem`;
      piece.style.height = `${index % 3 === 0 ? size : size * 1.6}rem`;
      piece.style.borderRadius = index % 3 === 0 ? '50%' : '0.15rem';
      drift.appendChild(piece);
      origin.appendChild(drift);

      const duration = random(1300, 2100);
      const delay = random(0, 160);
      const sideways = random(-210, 40);
      const rise = random(45, 120);
      const fall = random(90, 170);
      const spin = random(-620, 620);
      longest = Math.max(longest, duration + delay);

      /* Sideways motion slows down like air drag... */
      drift.animate([{ transform: 'translateX(0)' }, { transform: `translateX(${sideways}px)` }], {
        duration,
        delay,
        easing: 'cubic-bezier(0.12, 0.7, 0.3, 1)',
        fill: 'both',
      });

      /* ...while the vertical motion decelerates upwards and accelerates down, like gravity. */
      piece.animate(
        [
          { transform: 'translateY(0) rotate(0deg) scale(0.5)', opacity: 1, easing: 'cubic-bezier(0.2, 0.7, 0.4, 1)' },
          {
            transform: `translateY(${-rise}px) rotate(${spin * 0.4}deg) scale(1)`,
            opacity: 1,
            offset: 0.32,
            easing: 'cubic-bezier(0.55, 0, 0.9, 0.55)',
          },
          { transform: `translateY(${fall * 0.55}px) rotate(${spin * 0.85}deg) scale(1)`, opacity: 1, offset: 0.82 },
          { transform: `translateY(${fall}px) rotate(${spin}deg) scale(0.9)`, opacity: 0 },
        ],
        { duration, delay, fill: 'both' }
      );
    }

    setTimeout(() => origin.remove(), longest + 200);
  };

  const checkFreeShipping = () => {
    const bar = document.querySelector('cart-drawer .candly-freeship');
    if (!bar) {
      freeShippingReached = false;
      lastFreeShippingPercent = null;
      return;
    }
    if (bar.dataset.candlySeen) return;
    bar.dataset.candlySeen = 'true';

    const fill = bar.querySelector('.candly-freeship__bar span');
    const percent = fill ? parseFloat(fill.style.width) || 0 : 0;
    const reached = bar.classList.contains('candly-freeship--reached');
    const justReached = reached && !freeShippingReached;
    const animate = !reduceMotion();

    /* Grow (or shrink) the fill from where it was before this re-render. */
    if (fill && animate && lastFreeShippingPercent !== null && lastFreeShippingPercent !== percent) {
      fill.style.transition = 'none';
      fill.style.width = `${lastFreeShippingPercent}%`;
      if (justReached) bar.classList.add('candly-freeship--filling');
      void fill.offsetWidth;
      fill.style.transition = '';
      fill.style.width = `${percent}%`;
    }

    if (justReached) {
      const filling = bar.classList.contains('candly-freeship--filling');
      setTimeout(
        () => {
          bar.classList.remove('candly-freeship--filling');
          bar.classList.add('candly-freeship--celebrate');
          if (animate) throwConfetti(bar);
        },
        filling ? 650 : 0
      );
    }

    freeShippingReached = reached;
    lastFreeShippingPercent = percent;
  };

  /* Reviews carousel: advance on its own every few seconds, unless the app already does
     or the visitor is hovering it. */
  const REVIEWS_INTERVAL = 5000;
  let reviewsTimer = null;
  let lastReviewsPosition = null;

  const startReviewsAutoplay = () => {
    if (reviewsTimer || reduceMotion()) return;
    const section = document.querySelector('.candly-reviews');
    if (!section || !section.querySelector('.jdgm-carousel__right-arrow')) return;

    reviewsTimer = setInterval(() => {
      const track = section.querySelector('.jdgm-carousel__item-wrapper');
      const next = section.querySelector('.jdgm-carousel__right-arrow');
      if (!track || !next || document.hidden || section.matches(':hover, :focus-within')) return;

      const position = track.style.transform;
      if (position === lastReviewsPosition) next.click();
      lastReviewsPosition = track.style.transform;
    }, REVIEWS_INTERVAL);
  };

  /* Sort dropdown on collection and search pages (snippets/facets.liquid): the button shows the
     picked option, and the list closes once an option is clicked. */
  document.addEventListener('change', (event) => {
    const input = event.target.closest && event.target.closest('.candly-sort input[type="radio"]');
    if (!input) return;
    input.closest('.candly-sort').querySelector('.candly-sort__current').textContent = input
      .closest('label')
      .textContent.trim();
  });

  /* In the phone filter drawer, the drawer script treats every <summary> as a submenu and slides
     the whole list away, which left the drawer empty. The sort list opens in place instead, so
     its summary click is kept from reaching that script (the details still opens and closes). */
  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest && event.target.closest('menu-drawer .candly-sort--mobile > summary')) {
        event.stopPropagation();
      }
    },
    true
  );

  document.addEventListener('click', (event) => {
    const option = event.target.closest && event.target.closest('.candly-sort__option');
    /* A label click also fires a click on its input; act on that one, after the choice is made. */
    if (option && event.target.matches('input')) option.closest('.candly-sort').removeAttribute('open');
  });

  /* Shop tabs (sections/candly-shop-tabs.liquid): a tab shows its collection's panel below.
     Arrow keys move between tabs, as screen-reader users expect of a tab list. */
  if (!customElements.get('candly-tabs')) {
    customElements.define(
      'candly-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.skipShown();
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
          this.addEventListener('keydown', (event) => {
            const index = this.tabs.indexOf(document.activeElement);
            if (index < 0 || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
            const step = event.key === 'ArrowRight' ? 1 : -1;
            const next = this.tabs[(index + step + this.tabs.length) % this.tabs.length];
            this.select(next);
            next.focus();
          });
        }

        /* A candle already on the page above (hero, favourites) or in an earlier tab is not shown
           again; the hidden spare cards fill its place, so each row keeps its length. */
        skipShown() {
          const handleOf = (href) => {
            const match = /\/products\/([^/?#]+)/.exec(href || '');
            return match ? decodeURIComponent(match[1]) : null;
          };
          const main = this.closest('main') || document;
          const seen = new Set();
          main.querySelectorAll('a[href*="/products/"]').forEach((link) => {
            if (this.compareDocumentPosition(link) & Node.DOCUMENT_POSITION_PRECEDING) seen.add(handleOf(link.getAttribute('href')));
          });
          this.querySelectorAll('ul[data-show]').forEach((grid) => {
            const max = Number(grid.dataset.show);
            let shown = 0;
            grid.querySelectorAll(':scope > li[data-handle]').forEach((item) => {
              const show = shown < max && !seen.has(item.dataset.handle);
              item.classList.toggle('hidden', !show);
              if (!show) return;
              item.style.setProperty('--candly-i', shown);
              seen.add(item.dataset.handle);
              shown += 1;
            });
          });
        }

        select(tab) {
          this.tabs.forEach((other) => {
            const selected = other === tab;
            other.setAttribute('aria-selected', String(selected));
            other.tabIndex = selected ? 0 : -1;
            const panel = document.getElementById(other.getAttribute('aria-controls'));
            if (panel) panel.hidden = !selected;
          });
          /* Keep the chosen tab in view when the row scrolls sideways */
          const list = tab.parentElement;
          const left = tab.offsetLeft - (list.clientWidth - tab.offsetWidth) / 2;
          list.scrollTo({ left: Math.max(0, left), behavior: reduceMotion() ? 'auto' : 'smooth' });
        }
      }
    );
  }

  /* Product rows (sections/candly-spotlight.liquid) with "skip products already shown": a candle that
     is linked higher up the page, e.g. in the hero, is not shown again */
  document.querySelectorAll('.candly-spot[data-skip-shown]').forEach((spot) => {
    const main = spot.closest('main') || document;
    const seen = new Set();
    main.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      if (!(spot.compareDocumentPosition(link) & Node.DOCUMENT_POSITION_PRECEDING)) return;
      const match = /\/products\/([^/?#]+)/.exec(link.getAttribute('href') || '');
      if (match) seen.add(decodeURIComponent(match[1]));
    });
    spot.querySelectorAll('li[data-handle]').forEach((item) => {
      if (seen.has(item.dataset.handle)) item.classList.add('hidden');
    });
  });

  /* Product rows that scroll sideways (spotlight rows and review cards): dragged with the mouse on computers, and a thin bar under
     the row shows there is more to the right and how far along the visitor is */
  document.querySelectorAll('.candly-spot--row .candly-spot__grid, .candly-revcards__track').forEach((grid) => {
    const bar = document.createElement('div');
    bar.className = 'candly-spot__progress';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<span></span>';
    grid.after(bar);
    const thumb = bar.firstElementChild;
    const update = () => {
      const scrollable = grid.scrollWidth > grid.clientWidth + 4;
      bar.hidden = !scrollable;
      grid.classList.toggle('is-draggable', scrollable);
      if (!scrollable) return;
      const share = grid.clientWidth / grid.scrollWidth;
      thumb.style.width = share * 100 + '%';
      thumb.style.transform = `translateX(${(grid.scrollLeft / (grid.scrollWidth - grid.clientWidth)) * (1 / share - 1) * 100}%)`;
    };
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* Mouse drag; touch screens already swipe on their own */
    let startX = 0, startLeft = 0, moved = false, dragging = false;
    grid.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !grid.classList.contains('is-draggable')) return;
      if (event.target.closest('button, product-form, modal-opener, form')) return;
      dragging = true; moved = false; startX = event.clientX; startLeft = grid.scrollLeft;
      grid.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const dx = event.clientX - startX;
      if (Math.abs(dx) > 5) moved = true;
      grid.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!dragging) return;
      dragging = false;
      grid.classList.remove('is-dragging');
    });
    /* A drag is not a click: the candle under the mouse does not open */
    grid.addEventListener('click', (event) => { if (moved) { event.preventDefault(); event.stopPropagation(); moved = false; } }, true);
    grid.addEventListener('dragstart', (event) => event.preventDefault());
  });

  /* Theme editor: picking a tab block shows its panel */
  document.addEventListener('shopify:block:select', (event) => {
    const tab = event.target.closest && event.target.closest('candly-tabs [role="tab"]');
    if (tab) tab.click();
  });

  /* Delivery choice in the cart (snippets/candly-delivery.liquid). The BOX NOW app keeps the picked
     locker in the cart attributes and redraws its own markup when it changes; on such a change the
     cart is read again and the rows and the note follow it. */
  /* The app has one set of buttons in the drawer and another on the cart page */
  const BOXNOW_BUTTONS = {
    drawer: { open: '#tp-box-now-drawer-lockers-button', remove: '.tp-drawer-locker-remove-button' },
    page: { open: '.tp-boxnow-map-widget-button', remove: '.tp-box-now-locker-selection__details-unselect-btn' },
  };
  const BOXNOW_STATE = '#CandlyBoxNowSlot, .tp-box-now-locker-selection';
  let boxnowSignature = null;
  let boxnowTimer;

  const showDelivery = (locker) => {
    document.querySelectorAll('[data-candly-delivery]').forEach((box) => {
      box.dataset.locker = locker;
      box.querySelectorAll('[data-delivery]').forEach((option) => {
        const checked = option.dataset.delivery === 'boxnow' ? Boolean(locker) : !locker;
        option.setAttribute('aria-checked', String(checked));
      });
      const hint = box.querySelector('[data-delivery-locker]');
      if (hint) hint.textContent = locker || hint.dataset.empty;
    });
    document.querySelectorAll('[data-candly-delivery-note]').forEach((note) => {
      note.textContent = locker ? note.dataset.boxnow.replace('[locker]', locker) : note.dataset.courier;
    });
  };

  const checkDelivery = () => {
    if (!document.querySelector('[data-candly-delivery]')) return;
    const signature = [...document.querySelectorAll(BOXNOW_STATE)].map((element) => element.outerHTML).join('|');
    if (signature === boxnowSignature) return;
    boxnowSignature = signature;
    clearTimeout(boxnowTimer);
    boxnowTimer = setTimeout(() => {
      fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
        .then((response) => response.json())
        .then((cart) => showDelivery((cart.attributes && cart.attributes.boxnow_locker_name) || ''))
        .catch(() => {});
    }, 250);
  };

  document.addEventListener('click', (event) => {
    const option = event.target.closest && event.target.closest('[data-delivery]');
    if (!option) return;
    const drawer = option.closest('cart-drawer');
    const scope = drawer || option.closest('.cart__footer') || document;
    const buttons = drawer ? BOXNOW_BUTTONS.drawer : BOXNOW_BUTTONS.page;
    if (option.dataset.delivery === 'boxnow') {
      const open = scope.querySelector(buttons.open);
      if (open) open.click();
    } else if (option.closest('[data-candly-delivery]').dataset.locker) {
      const remove = scope.querySelector(buttons.remove);
      if (remove) remove.click();
      /* Show the courier row at once; the app takes a moment, and the reads below put the row
         back if the locker stayed */
      showDelivery('');
    }
    /* Read the cart again shortly after, in case the app's change shows nowhere in its markup */
    [800, 2000].forEach((delay) =>
      setTimeout(() => {
        boxnowSignature = null;
        checkDelivery();
      }, delay)
    );
  });

  /* Arrow keys move between the two rows, as in any radio group */
  document.addEventListener('keydown', (event) => {
    const option = event.target.closest && event.target.closest('[data-delivery]');
    if (!option || !['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    const options = [...option.parentElement.querySelectorAll('[data-delivery]')];
    const next = options[(options.indexOf(option) + 1) % options.length];
    next.focus();
    next.click();
  });


  /* Product page on phones: the sticky add bar (snippets/candly-sticky-buy.liquid). It shows while
     the page's own Add to cart button is above the screen, and presses that button. */
  if (!customElements.get('candly-sticky-buy')) {
    customElements.define(
      'candly-sticky-buy',
      class extends HTMLElement {
        connectedCallback() {
          if (this.closest('quick-add-modal')) return;
          this.querySelector('[data-sticky-add]').addEventListener('click', () => {
            const main = this.mainButton();
            if (main && !main.disabled) main.click();
            else if (main) main.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
          });
          this.onScroll = () => this.update();
          window.addEventListener('scroll', this.onScroll, { passive: true });
          document.addEventListener('change', this.onScroll);
          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          document.removeEventListener('change', this.onScroll);
        }

        mainButton() {
          return document.querySelector(`#ProductSubmitButton-${this.dataset.section}`);
        }

        update() {
          const main = this.mainButton();
          if (!main) return;
          const past = main.getBoundingClientRect().bottom < 0;
          this.hidden = false;
          this.classList.toggle('is-visible', past);
          this.setAttribute('aria-hidden', String(!past));
          this.querySelector('[data-sticky-add]').tabIndex = past ? 0 : -1;
          if (!past) return;
          /* The chosen option values and the current price, as the page shows them */
          const values = [...document.querySelectorAll(`#variant-selects-${this.dataset.section} input:checked, #variant-selects-${this.dataset.section} select`)]
            .map((input) => (input.tagName === 'SELECT' ? input.selectedOptions[0]?.textContent.trim() : input.value))
            .filter(Boolean);
          const priceBox = document.querySelector(`#price-${this.dataset.section} .price`);
          const price =
            priceBox &&
            priceBox.querySelector(
              priceBox.classList.contains('price--on-sale') ? '.price__sale .price-item--last' : '.price__regular .price-item--regular'
            );
          /* A gift card's amount is also its price, so it is shown once */
          const meta = [...new Set([...values, price ? price.textContent.trim() : ''].filter(Boolean))].join(' · ');
          const metaElement = this.querySelector('[data-sticky-meta]');
          if (metaElement.textContent !== meta) metaElement.textContent = meta;
          const button = this.querySelector('[data-sticky-add]');
          button.disabled = Boolean(main.disabled);
        }
      }
    );
  }

  /* Shopify Forms: on phones its side tab ("✨ Το δώρο σου -10% ✨") wrapped onto two lines and grew
     very wide. The app draws inside an open shadow root, so a small stylesheet is added there:
     one line, smaller type, a slimmer tab. Selectors use the app's data attributes, not its
     generated class names. */
  const FORMS_STYLE = `
    @media (max-width: 749px) {
      #app-embed[data-current-step='tease'] { width: auto !important; }
      [data-testid='form-teaser'] { padding: 8px 12px !important; min-height: 0 !important; gap: 8px !important; }
      [data-testid='form-teaser'] h3 { white-space: nowrap !important; font-size: 13px !important; line-height: 1.2 !important; margin: 0 !important; }
    }`;
  const styleFormsEmbed = () => {
    document.querySelectorAll('shopify-forms-embed').forEach((embed) => {
      const root = embed.shadowRoot;
      if (!root || root.querySelector('#candly-forms-style')) return;
      const style = document.createElement('style');
      style.id = 'candly-forms-style';
      style.textContent = FORMS_STYLE;
      root.appendChild(style);
    });
  };
  /* The embed attaches its shadow root a little after it is inserted, so check again a few times */
  [1000, 3000, 6000, 12000].forEach((delay) => setTimeout(styleFormsEmbed, delay));

  const run = () => {
    shortenNames();
    checkFreeShipping();
    startReviewsAutoplay();
    checkDelivery();
    styleFormsEmbed();
  };

  const start = () => {
    run();
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
